const STORAGE_KEY = 'hb_correlation_id';

/**
 * Stable per-tab correlation id for API requests (sessionStorage).
 */
export function getOrCreateCorrelationId(): string {
  if (typeof window === 'undefined') return '';
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing && existing.trim()) return existing.trim();
    const id = crypto.randomUUID();
    sessionStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}
